// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Ouroboros_Models_Documents_Documents from "../Ouroboros.Models.Documents.Documents/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_List_Types.showNonEmptyList(Foreign.showForeignError));
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var validateSubmitFeedbackResponse = function (response) {
    return Ouroboros_Models_Documents_Documents.isNonEmpty(response.feedback_id);
};
var readJson = function (dictReadForeign) {
    var read = Simple_JSON.read(dictReadForeign);
    return function (value) {
        return lmap(show)(read(value));
    };
};
var readJson1 = /* #__PURE__ */ readJson(/* #__PURE__ */ Simple_JSON.readRecord()(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "feedback_id";
    }
})(Simple_JSON.readString)(Simple_JSON.readFieldsNil)()()));
var failWith = function (message) {
    return new Data_Either.Left(message);
};
var decodeSubmitFeedbackResponse = function (value) {
    return bind(readJson1(value))(function (decoded) {
        var $15 = validateSubmitFeedbackResponse(decoded);
        if ($15) {
            return new Data_Either.Right(decoded);
        };
        return failWith("Invalid feedback response payload");
    });
};
export {
    decodeSubmitFeedbackResponse
};
//# sourceMappingURL=index.js.map
